/* istanbul ignore file */

export const getRect = (el: Element | null, property: keyof Omit<DOMRect, 'toJSON'>) =>
  el?.getBoundingClientRect()[property] ?? 0;

export const getPagePosition = (el: Element | null) =>
  (window.pageYOffset || document.documentElement.scrollTop) + getRect(el, 'top');
